import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
  import { CALENDLY_DEMO_LINK } from "@/constants/calendlyLinks";
  import { scrollTo } from "@/helpers/smoothScrollToElement";
  import { redirectWithoutRouter } from "@/helpers/redirectWithoutRouter";
  import { useIsDesktop } from "@/features/useIsDesktop";
  import { POSITION, useToast } from "vue-toastification";

  declare global {
    interface Window {
      Calendly: {
        showPopupWidget: (url: string) => void;
      };
    }
  }
  const FIXED_HEADER_HEIGHT = 140;
  
export default /*@__PURE__*/_defineComponent({
  __name: 'ContactUsLink',
  props: {
    linkCalendly: {
      type: String,
      default: CALENDLY_DEMO_LINK as string,
    },
    toContactUsForm: {
      type: Boolean,
      default: true,
    },
    text: {
      type: String,
      default: "Talk with us",
    },
    animationName: {
      type: String,
      default: "fade-up",
    },
    isButtonCallBackModal: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["closeModal"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const emit = __emit;

  const toast = useToast();
  const showWidget = () => {
    if (window.Calendly) {
      emit("closeModal");
      window.Calendly.showPopupWidget(props.linkCalendly);
    } else {
      toast.error("Calendly script not loaded", {
        position: POSITION.TOP_LEFT,
      });
    }
  };

  const { isDesktop } = useIsDesktop();
  const onClick = () => {
    if (!props.toContactUsForm) {
      showWidget();
      return;
    }

    const contactUsForm = document.querySelector("#contact-us-form");

    if (contactUsForm)
      scrollTo(contactUsForm, !isDesktop.value ? FIXED_HEADER_HEIGHT : 0, 800);
  };
  const props = __props;

const __returned__ = { emit, toast, showWidget, isDesktop, FIXED_HEADER_HEIGHT, onClick, props, computed, get CALENDLY_DEMO_LINK() { return CALENDLY_DEMO_LINK }, get scrollTo() { return scrollTo }, get redirectWithoutRouter() { return redirectWithoutRouter }, get useIsDesktop() { return useIsDesktop }, get POSITION() { return POSITION }, get useToast() { return useToast } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})